import Header from 'components/headers/addLoan'
import AddIcon from 'assets/images/settlements/add.svg'
import Footer from './footer'
import useGetCards from 'pages/loans/add/hooks/useGetCards'
import DotsLoading from 'components/loadings/dotsLoading'
import { useLocation, useParams } from 'react-router-dom'
import CardsModal from 'pages/loans/add/modal'
import { useState } from 'react'
import { BankConvertor } from 'utilities/helper/banksConvertor'
import { Field, Form, Formik } from 'formik'
import useAddSettlement from './hooks/useAddSettlement'
import { toast } from 'react-toastify'
import { Schema } from './utilities'
interface ISelectCard {
    isOpen: boolean
    name: string
    bank: string
    bankNumber: number
}
export default function AddSettlement() {
    const { id } = useParams()
    const [isOpenCard, setOpenCard] = useState<ISelectCard>({
        isOpen: false,
        name: '',
        bank: '',
        bankNumber: 0,
    })
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const { mutate, isLoading } = useAddSettlement()
    return (
        <>
            <Formik
                initialValues={{ description: '' }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    if (isOpenCard.bankNumber) {
                        const payload: ISetSettlementPayload = {
                            discription: values.description,
                            selected_card_number: isOpenCard.bankNumber,
                            id,
                        }
                        mutate(payload)
                    } else {
                        toast.error('لطفا کارت را انتخاب کنید!')
                    }
                }}
            >
                {({ values, touched, errors }) => (
                    <Form>
                        <>
                            <div className=" h-screen">
                                <Header title="تسویه و خروج" />
                                <div className=" mt-20 bg-white mx-3 text-center relative pt-16">
                                    <img
                                        src={AddIcon}
                                        alt="add"
                                        className=" absolute -top-10 h-20 w-20 left-[40%] md:left-1/2 md:-translate-x-1/2"
                                    />
                                    <p className=" border-b border-gray-4 my-2 border-dashed py-2">
                                        {profile &&
                                            `${profile.first_name} ${profile.last_name}`}
                                    </p>
                                    <p
                                        className=" border-b border-gray-4 my-2 border-dashed py-2"
                                        onClick={() =>
                                            setOpenCard({
                                                ...isOpenCard,
                                                isOpen: true,
                                            })
                                        }
                                    >
                                        شماره حساب
                                    </p>
                                    <Field
                                        type="text"
                                        name="description"
                                        className=" border-b border-gray-4 my-2 border-dashed py-2 w-full text-center"
                                        placeholder="توضیحات"
                                    />
                                    {touched.description &&
                                        errors.description && (
                                            <p className=" text-sm text-error-3">
                                                {errors.description}
                                            </p>
                                        )}
                                </div>

                                <Footer isLoading={isLoading} />
                            </div>
                        </>
                    </Form>
                )}
            </Formik>
            <CardsModal
                show={isOpenCard.isOpen}
                onHide={() =>
                    setOpenCard({
                        ...isOpenCard,
                        isOpen: false,
                    })
                }
                setOpenCard={setOpenCard}
            />
        </>
    )
}
